const printableToPathlike = (s: string) => {
  return encodeURIComponent(s?.toLowerCase().replaceAll('-', '$').replaceAll(' ', '-'));
};

export default printableToPathlike;